import React from 'react';
// import {Container,Row} from 'react-bootstrap';
import './Header.css';
// import { Link } from "react-router-dom";

function Header() {
    window.addEventListener("scroll",function(){
        let header = this.document.querySelector("header");
        header.classList.toggle("sticky",this.window.scrollY > 0)
    })
    // toggle between appearing & disappearing

    
        
    const toggleMenu = () => {
        let navbar = document.querySelector('.header__container .nav');
        let menu = document.querySelector('#menu-btn');
        menu.classList.toggle('fa-times')
        navbar.classList.toggle('active')
    }

    

 

    


    return (
        <header className='header' id='home'>


            <div className='header__container'>
                {/* <a href='#home' className='header__logo'>Royal <span>Smiles</span></a> */}
                <a href ='#home' className='header__logo'>
                    <img alt="logo"  className='header__logo' src='/images/logo1.png'/>
                </a>

                <nav className="nav">
                    <a href='#slider'>Home</a>
                    <a href='#about'>About Us</a>
                    <a href='#services'>Services</a>
                    <a href='#partners'>Partners</a>
                    <a href='#contact'>Contact Us</a>
                </nav>

                
                <a href='#contact' className='link-btn'> Make Appointment</a>

                <div id="menu-btn" className="fas fa-bars" onClick={()=>toggleMenu()}></div>


            </div>


        </header>
);
}

export default Header;
